import { Card, Input } from 'antd';
import React, { useContext, useEffect, useState } from 'react';
import { loadProductForSells } from '../apis/productAPI';
import camera from '../utils/camera.png';
import EventEmitter from '../../utils/eventEmitter';
import Loading from './Loading';
import PosSessionContext from '../utils/PosSessionContext';
import Axios from '../utils/axios';



const gridStyle = {
  width: '16.65%',
  height: '200px',
  padding: '4px',
};

const ProductCard = ({products, handleAddToCart}) => {
  return (
    <Card className={`${products.length > 0 ? 'block' : 'hidden'} rounded-none`}>
      {products.map((product, id) =>
        <Card.Grid key={id} onClick={()=>handleAddToCart(product)} className='flex flex-col items-center text-center hover:cursor-pointer relative' style={gridStyle}>
          <span className='absolute right-1 bg-blue-100 px-1 text-blue-800' style={{fontSize: '12px'}}>{product.available_quantity && product.available_quantity + ' Units'} </span>
          <div className='h-3/4' ><img className='h-full' src={product.image_uri ? product.image_uri : camera} height={40}/></div>
          <p className='font-md line-clamp-2'>{product.name}</p>
          <span className='font-semibold'>GHc {product.sales_price}</span>
        </Card.Grid>
      )}
    </Card>
  )
}

const ProductPage = () => {
  const { state } = useContext(PosSessionContext);
  const [products, setProducts] = useState([]);
  const [searchedProducts, setSearchedProducts] = useState('');
  

  useEffect(() => {
    let pos_id = state.pos_id;
    loadProductForSells(pos_id)
    .then(res => setProducts(res))
    .catch(err => console.log(err));
  },[])

  const handleAddToCart = (product) => EventEmitter.dispatch('posAddToCart', product);

  const nothingToDo = () => {};


  const handleSearch = (e) => {
    let debounceTimeout = null;
    let search = e.target.value;
    let products_ = [...products];
    if (debounceTimeout) {
      clearTimeout(debounceTimeout);
    }
    debounceTimeout = setTimeout(() => {
      if (search.length > 0) {
        const searchedProducts_ = products.filter(product =>
          product.name.toLowerCase().includes(search.toLowerCase())
        );
        console.log(searchedProducts_)
        if (searchedProducts_.length > 0) {
          
          setSearchedProducts(searchedProducts_);
        }else {
          Axios(`products/searchquery=${search.toLowerCase()}`)
          .then(res => setSearchedProducts(res.data))
          .catch(err => console.log(err))
        }
      }else {
        setSearchedProducts([]);
      }
    }, 800);
  }

  const handleKeyboardInput = (event) => {
    const key = event.key;
    
    // Check if the key is a number (0-9) or decimal point (.)
    if (event.ctrlKey || event.key === 'Control' || event.key === 'Fn') {
      // event.preventDefault(); // Prevent default behavior of these keys
      console.log("Ctrl or Fn key pressed, action prevented.");
    }else {
      if (/[0-9]/.test(key)) {
      }
        // Check for Enter key to trigger calculation
      else if (key === "Enter") {
        // handleOk();
        console.log('enter pressed');
      }
      // Check for backspace key to clear the last character (delete)
      else if (key === "Backspace") {
        console.log('backspace pressed');
      }
      // Check for Escape key to clear the display
      else if (key === "Escape") {
        // resetPasscode();
          console.log('esc pressed');
      }
    }
  };

  return (
    <div>
      <div className='flex justify-end' style={{border: '1px solid lightgray'}}>
        <Input type='text' id='product-search' onChange={products.length > 0 ? handleSearch : nothingToDo} className='input-outline-none' placeholder='search product' />
      </div>
      
        <ProductCard products={searchedProducts.length > 0 ? searchedProducts : products} handleAddToCart={handleAddToCart}/>
        {products.length <= 0 && <Loading />}
    </div>
  )
}

export default ProductPage;